import { useCallback } from 'react';
import { useAuth } from '../../../context/AuthContext';

const API = (process.env.REACT_APP_API_URL || '/api').replace(/\/$/, '');
export const REQUEST_TIMEOUT_MS = 120000; // 2 minutes for photo uploads and DB operations

export function readTokenFromStorage() {
  if (typeof window === "undefined") return "";
  try {
    const tokenKey = Object.keys(localStorage).find(
      (k) => k.startsWith("sb-") && k.endsWith("-auth-token")
    );
    if (!tokenKey) return "";
    const raw = localStorage.getItem(tokenKey);
    if (!raw) return "";
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) return parsed[0]?.access_token || "";
    return parsed?.access_token || "";
  } catch {
    return "";
  }
}

const withRequestTimeout = (promise, ms = REQUEST_TIMEOUT_MS) =>
  Promise.race([
    promise,
    new Promise((_, reject) => setTimeout(() => reject(new Error("request timeout")), ms)),
  ]);

const doAdminFetch = (token, path, options = {}) => {
  const { timeoutMs, signal, ...fetchOptions } = options;
  const headers = new Headers(fetchOptions.headers || {});
  if (token) headers.set("Authorization", `Bearer ${token}`);

  const url = path.startsWith("/api/")
    ? (API.startsWith("http://") || API.startsWith("https://")
        ? `${API.replace(/\/api$/, "")}${path}`
        : path)
    : `${API}${path.startsWith("/") ? "" : "/"}${path}`;

  return withRequestTimeout(
    fetch(url, { ...fetchOptions, headers, signal }),
    timeoutMs ?? REQUEST_TIMEOUT_MS
  );
};

export function useAdminFetch() {
  const { session } = useAuth();
  const accessToken = session?.access_token || "";

  return useCallback(
    (path, options = {}) => {
      const token = accessToken || readTokenFromStorage();
      return doAdminFetch(token, path, options);
    },
    [accessToken]
  );
}
